const axios = require('axios').default

const employeesApi = axios.create({
    baseURL: process.env.REACT_APP_BACKEND,
})

export const getByUser = async ({ params }) => {
    return new Promise((resolve, reject) => {
        employeesApi.get('/get_employees', {
            params
        }).then(resp => {
            resolve(resp.data);
        }).catch(
            (err) => reject(err)
        )
    })
}

export const getEmployeeDataById = async (id) => {
    if (!id) throw new Error('id is required');
    try {
        const resp = await employeesApi.get('/get_employee_data', { params: { id } });
        return resp.data;
    } catch (e) {
        console.error('[employeesApi] getEmployeeDataById error', e);
        throw e;
    }
}
